export default (props) => (
  /**
   * Ícone "+" com circunferência em volta. Utilizado para
   * representar adição de camadas do catálogo de camadas
   * ao menu.
   * Cor parametrizada.
   */
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12.9985"
      cy="12.3254"
      r="11.5"
      stroke={props.stroke || 'currentColor'}
    />
    <rect
      x="12.0685"
      y="5.49429"
      width="1.78889"
      height="14"
      rx="0.894445"
      fill={props.fill || 'currentColor'}
    />
    <rect
      x="19.9628"
      y="11.601"
      width="1.78666"
      height="14"
      rx="0.893328"
      transform="rotate(90 19.9628 11.601)"
      fill={props.fill || 'currentColor'}
    />
  </svg>
);
